export default __webpack_public_path__ + "static/media/deleteactivity.4e92605b.gif";